__turbopack_context__.v({
  "body": "ModalBody-module__z4xvqW__body",
  "dark": "ModalBody-module__z4xvqW__dark",
  "hasBottomScrollIndicator": "ModalBody-module__z4xvqW__hasBottomScrollIndicator",
  "wrapper": "ModalBody-module__z4xvqW__wrapper",
});
